import React, { useCallback } from "react";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";
import { Card, Spinner, useFlash, SNACKBAR_TYPES, Snackbar, Button, } from "@lysaab/ui-2";
import "./OnfidoProcessPage.scss";
import { ConfirmStatus } from "../../data/onfido";
import { Onfido } from "./Onfido";
import { useOnfidoToken } from "../../hooks/useOnfidoToken";
const messages = defineMessages({
    onfidoInternalError: { id: "onfido.process.onfido_internal_error" },
    onfidoTokenRetry: { id: "onfido.process.token_retry" },
    onfidoTokenError: { id: "onfido.process.token_error" },
    onfidoInvalidLink: { id: "onfido.process.invalid_link" },
});
let refetchCount = 0;
export const OnfidoProcessPage = ({ next, restart, onUserError, onFatalError, confirm, getToken, country, locale, phrases = {}, steps, allowedDocuments, signupId, resetId, track, }) => {
    const pushFlash = useFlash();
    const { formatMessage } = useIntl();
    const { token, loading, error, resetToken, refetchToken } = useOnfidoToken(getToken);
    const showSpinner = !token || loading;
    const onError = useCallback((data) => {
        if (data.type !== "expired_token") {
            pushFlash({
                text: formatMessage(messages.onfidoInternalError),
                type: SNACKBAR_TYPES.ERROR,
            });
            console.error(data);
        }
        setTimeout(() => {
            if (refetchCount < 3) {
                refetchToken();
                refetchCount++;
            }
            else {
                console.error(data);
                pushFlash({
                    text: formatMessage(messages.onfidoInternalError),
                    type: SNACKBAR_TYPES.ERROR,
                });
            }
        }, 2000);
    }, [formatMessage, refetchToken, pushFlash]);
    const internalOnConfirm = useCallback((data) => {
        confirm(data)
            .then((status) => {
            if (status.checkStatus === ConfirmStatus.OK) {
                resetToken();
                next();
            }
            else {
                onUserError({ checkStatus: "ONFIDO_USER_ERROR" });
            }
        })
            .catch(() => {
            onFatalError();
        });
    }, [confirm, resetToken, next, onUserError, onFatalError]);
    return (React.createElement("div", { className: "onfido-process-page" },
        React.createElement(Card, null,
            React.createElement("div", { className: "overlay-wrapper-position" },
                error && React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR }, error),
                showSpinner && (React.createElement("div", { className: "loading-wrapper" },
                    React.createElement(Spinner, null),
                    React.createElement("div", { className: "loading-info" },
                        React.createElement("p", { className: "loading-text" },
                            React.createElement(FormattedMessage, { id: "onfido.process.loading" }),
                            React.createElement("span", { className: "ellipsis" }, "\u2026")))))),
            React.createElement(Onfido, { className: showSpinner ? "hidden-mount" : "", confirm: internalOnConfirm, country: country, locale: locale, steps: steps, allowedDocuments: allowedDocuments, phrases: phrases, token: token, onError: onError, signupId: signupId, resetId: resetId, track: track })),
        error && !showSpinner && (React.createElement(Button, { onClick: restart, block: true, label: React.createElement(FormattedMessage, { id: "onfido.process.button.error" }) }))));
};
